import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { of, throwError } from 'rxjs';

import { constants } from '../constants';
import { ENDPOINTS } from '~environments/environment';

export const onboardExpene500 = () => {
  return [
    // 1
    {
      [ENDPOINTS.API_MICROSERVICE_RETRIEVE_ONBOARD_PAYMENT]: () => {
        return throwError(new HttpErrorResponse({status: 500}));
      }
    },
  ];
};

export const onboardExpene200 = () => {
	const result = [
		// 1
		{
			[ENDPOINTS.API_MICROSERVICE_RETRIEVE_ONBOARD_PAYMENT]: () => {
				return of(
					new HttpResponse({
						body: {
							status: 500,
							errors: [
								{
									internalMessage: 'Unknown error occurred.',
									id: '804acad0-2c2f-443e-a5ec-bd67b176a9ae',
									time: 1525122442920
								}
							]
						}
					})
				);
			}
		}
	];

	return result;
};
